import c, { useState as u, useRef as H, useEffect as O, useMemo as E } from "react";
import { useTranslations as w, useKnockSlackClient as z, useSlackChannels as G, useConnectedSlackChannels as W } from "@knocklabs/react-core";
import * as S from "@radix-ui/react-popover";
import * as X from "@radix-ui/react-visually-hidden";
import { Spinner as j } from "../../../core/components/Spinner/Spinner.mjs";
/* empty css                                          */
import "lodash.debounce";
import q from "../../../core/hooks/useOutsideClick.mjs";
/* empty css               */
import J from "../SlackAddChannelInput/SlackAddChannelInput.mjs";
import Q from "./SlackChannelListBox.mjs";
import Y from "./SlackConnectedChannelTagList.mjs";
import Z from "./SlackConnectionError.mjs";
import { strContains as g } from "./helpers.mjs";
import M from "./icons/SearchIcon.mjs";
/* empty css            */
const nn = 1e3, bn = ({
  slackChannelsRecipientObject: R,
  queryOptions: y,
  inputProps: I,
  inputContainerProps: U,
  listBoxProps: $,
  channelOptionProps: D,
  inputMessages: n,
  showConnectedChannelTags: K = !1
}) => {
  const {
    t: l
  } = w(), [C, p] = u(!1), [x, L] = u(""), N = H(null);
  q({
    ref: N,
    fn: () => {
      L(""), p(!1);
    }
  });
  const {
    connectionStatus: a,
    errorLabel: T
  } = z(), {
    data: t,
    isLoading: s
  } = G({
    queryOptions: y
  }), {
    data: h,
    updateConnectedChannels: f,
    loading: P,
    error: d,
    updating: v
  } = W({
    slackChannelsRecipientObject: R
  }), [r, _] = u(null);
  O(() => {
    C && setTimeout(() => {
      var e;
      (e = document.getElementById("slack-channel-search")) == null || e.focus();
    }, 0);
  }, [C]), O(() => {
    const e = new Map(t.map((o) => [o.id, o])), i = (h == null ? void 0 : h.filter((o) => e.has(o.channel_id || ""))) || [];
    _(i);
  }, [h, t]);
  const m = E(() => a === "disconnected" || a === "error" || d, [d, a]), b = E(() => a === "connecting" || a === "disconnecting" || s, [a, s]), V = E(() => {
    const e = {
      disconnected: l("slackSearchbarDisconnected"),
      multipleChannelsConnected: l("slackSearchbarMultipleChannels"),
      noChannelsConnected: l("slackSearchbarNoChannelsConnected"),
      noSlackChannelsFound: l("slackSearchbarNoChannelsFound"),
      channelsError: l("slackSearchbarChannelsError")
    };
    if (a === "disconnected")
      return (n == null ? void 0 : n.disconnected) || e.disconnected;
    if (a === "error")
      return (n == null ? void 0 : n.error) || T;
    if (!b && t.length === 0)
      return (n == null ? void 0 : n.noSlackChannelsFound) || e.noSlackChannelsFound;
    if (d)
      return d;
    const i = (r == null ? void 0 : r.length) || 0;
    if (r && i === 0)
      return (n == null ? void 0 : n.noChannelsConnected) || e.noChannelsConnected;
    if (r && i === 1) {
      const o = t == null ? void 0 : t.find((k) => {
        var A;
        return k.id === ((A = r[0]) == null ? void 0 : A.channel_id);
      });
      return (n == null ? void 0 : n.singleChannelConnected) || `# ${o == null ? void 0 : o.name}`;
    }
    return r && i > 1 ? (n == null ? void 0 : n.multipleChannelsConnected) || `${i} channels connected` : "";
  }, [a, b, t, d, r, n, T, l]), F = async (e) => {
    if (!r)
      return;
    if (r.find((o) => o.channel_id === e)) {
      const o = r.filter((k) => k.channel_id !== e);
      _(o), f(o);
    } else {
      const o = [...r, {
        channel_id: e
      }];
      _(o), f(o);
    }
  }, B = t.filter((e) => g(e.name, x));
  return t.length > nn ? /* @__PURE__ */ c.createElement(J, { inErrorState: !!m, connectedChannels: r || [], updateConnectedChannels: f, connectedChannelsError: d, connectedChannelsUpdating: v }) : /* @__PURE__ */ c.createElement("div", { ref: N, className: "rsk-combobox" }, /* @__PURE__ */ c.createElement(S.Root, { open: a !== "disconnected" ? C : !1 }, /* @__PURE__ */ c.createElement(X.Root, null, /* @__PURE__ */ c.createElement("label", { htmlFor: "slack-channel-search" }, l("slackSearchChannels"))), /* @__PURE__ */ c.createElement(S.Trigger, { asChild: !0 }, /* @__PURE__ */ c.createElement("div", { className: "rsk-combobox__searchbar" }, /* @__PURE__ */ c.createElement("div", { className: "rsk-combobox__searchbar__input-container", ...U }, /* @__PURE__ */ c.createElement("div", { className: `rsk-combobox__searchbar__input-container__icon ${m && "rsk-combobox__searchbar__input-container__icon--error"}` }, b ? /* @__PURE__ */ c.createElement(j, { size: "15px", thickness: 3 }) : /* @__PURE__ */ c.createElement(M, null)), /* @__PURE__ */ c.createElement("input", { className: `rsk-combobox__searchbar__input-container__input ${m ? "rsk-combobox__searchbar__input-container__input--error" : ""}`, tabIndex: -1, id: "slack-channel-search", type: "text", onFocus: () => t.length > 0 && p(!0), onChange: (e) => L(e.target.value), value: x, placeholder: V || "", disabled: !!m, ...I })), /* @__PURE__ */ c.createElement(Z, null))), /* @__PURE__ */ c.createElement(S.Content, null, /* @__PURE__ */ c.createElement(Q, { isLoading: s || P, isUpdating: v, connectedChannels: r, onClick: F, slackChannels: B, listBoxProps: $, channelOptionProps: D }))), K && /* @__PURE__ */ c.createElement(Y, { connectedChannels: r, slackChannels: t, updateConnectedChannels: F }));
};
export {
  bn as SlackChannelCombobox
};
//# sourceMappingURL=SlackChannelCombobox.mjs.map
